// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"8c6d5514","846":"acbcd32c"}[chunkId] + ".css";
};